module.exports = {
    title: {
        en: "Welcome Break Doncaster",
        cy: "",
    },

    description: {
        en: "",
        cy: ""
    },

    socialImage: "https://placehold.co/600x400",

    company: {
        address: "",
        phoneNumber: "",
        number: "",
    },

    email: ""
}